import { routes } from '../router'

export const resourceRequiredFieldsList = [
  'title',
  'subtopics'
]

export const resourcePresentationRequiredFieldsList = [
  'rhetoricalQuestion',
  'benefits',
  'subjects',
  'skills',
  'odSs'
]

export const resourceTeacherRequiredFieldsList = [
  'pedagogicalGoal',
  'globalValuationSection'
]

export const resourceStudentRequiredFieldsList = [
  'studentPedagogicalGoal'
]

export const resourceTeacherClassRequiredFieldsList = [
  'organizationType',
  'classLayout',
  'minutesDuration',
  'startSection',
  'developmentSection',
  'closureSection',
  'valuationSection'
]

export const resourceStudentClassRequiredFieldsList = [
  'studentStatement'
]

export const getCompletedClassField = (resourceCompleteness, classNumber, field) => {
  if (!resourceCompleteness.classPlans.length) return false
  const resClass = resourceCompleteness.classPlans.find(resClass => resClass.classNumber === classNumber)
  return field === 'valuationSection'
    ? resourceCompleteness.globalValuationSection || resClass[field]
    : resClass[field]
}

export const getCompletedField = (resourceCompleteness, field) => {
  if (field === 'globalValuationSection') {
    if (resourceCompleteness[field]) return true
    else {
      return resourceCompleteness.classPlans.length
        ? resourceCompleteness.classPlans.every(resClass => getCompletedClassField(resourceCompleteness, resClass.classNumber, 'valuationSection'))
        : false
    }
  }
  return resourceCompleteness[field]
}

export const getResourceCompletedClasses = (resourceCompleteness, type) => {
  let allClassFields
  if (type === 'teacher') {
    allClassFields = resourceTeacherClassRequiredFieldsList
  } else if (type === 'student') {
    allClassFields = resourceStudentClassRequiredFieldsList
  } else {
    allClassFields = [...resourceTeacherClassRequiredFieldsList, ...resourceStudentClassRequiredFieldsList]
  }
  const completedClasses = resourceCompleteness.classPlans.filter(resClass =>
    allClassFields.filter(field => getCompletedClassField(resourceCompleteness, resClass.classNumber, field)).length === allClassFields.length
  )
  return completedClasses
}

export const getResourceCompletedFieldsAmount = (resourceCompleteness) => {
  const allResourceFields = [
    ...resourceRequiredFieldsList,
    ...resourcePresentationRequiredFieldsList,
    ...resourceTeacherRequiredFieldsList,
    ...resourceStudentRequiredFieldsList
  ]
  const allClassFields = [
    ...resourceTeacherClassRequiredFieldsList,
    ...resourceStudentClassRequiredFieldsList
  ]

  let resCompleted = 0
  let classCompleted = 0

  allResourceFields.forEach(field => {
    if (getCompletedField(resourceCompleteness, field)) {
      resCompleted++
    }
  })
  resourceCompleteness.classPlans.forEach(resClass => {
    allClassFields.forEach(field => {
      if (getCompletedClassField(resourceCompleteness, resClass.classNumber, field)) {
        classCompleted++
      }
    })
  })

  return resCompleted + classCompleted
}

export const resourceFieldsRoutes = {
  title: routes.kreaResourcePresentation,
  subtopics: routes.kreaResourcePresentation,
  rhetoricalQuestion: routes.kreaResourcePresentation,
  benefits: routes.kreaResourcePresentation,
  subjects: routes.kreaResourcePresentation,
  skills: routes.kreaResourcePresentation,
  odSs: routes.kreaResourcePresentation,
  classPlanDescription: routes.kreaResourceTeacherTrigger,
  pedagogicalGoal: routes.kreaResourceTeacherTrigger,
  globalValuationSection: routes.kreaResourceTeacherValuation,
  studentPedagogicalGoal: routes.kreaResourceStudentTrigger,
  organizationType: routes.kreaResourceTeacherClass,
  classLayout: routes.kreaResourceTeacherClass,
  minutesDuration: routes.kreaResourceTeacherClass,
  startSection: routes.kreaResourceTeacherClass,
  developmentSection: routes.kreaResourceTeacherClass,
  closureSection: routes.kreaResourceTeacherClass,
  valuationSection: routes.kreaResourceTeacherClass,
  studentStatement: routes.kreaResourceStudentClass
}
